import apiClient from './apiClient';

export interface ScalingSetting {
  formatId: string;
  formatIdentifier: string | null;
  formatLabel: string | null;
  themeId: string;
  themeLabel: string | null;
  sportIdentifier: string;
  factor: number;
  roundingStep: number;
}

export interface ScalingList {
  items: ScalingSetting[];
  total: number;
}

export interface ScalingCreatePayload {
  formatId: string;
  themeId: string;
  sportIdentifier: string;
  factor: number;
  roundingStep: number;
}

export interface ScalingUpdatePayload {
  factor: number;
  roundingStep: number;
}

export const getScalingSettings = async (filters: {
  theme?: string;
  sport?: string;
  format?: string;
  page?: number;
  pageSize?: number;
}): Promise<ScalingList> => {
  const response = await apiClient.get('admin/scaling', { params: filters });
  return response.data as ScalingList;
};

export const createScalingSetting = async (payload: ScalingCreatePayload): Promise<ScalingSetting> => {
  const response = await apiClient.post('admin/scaling', payload);
  return response.data as ScalingSetting;
};

export const updateScalingSetting = async (
  formatId: string,
  themeId: string,
  sportIdentifier: string,
  payload: ScalingUpdatePayload
): Promise<ScalingSetting> => {
  const response = await apiClient.put(`admin/scaling/${formatId}/${themeId}/${sportIdentifier}`, payload);
  return response.data as ScalingSetting;
};

export const deleteScalingSetting = async (
  formatId: string,
  themeId: string,
  sportIdentifier: string
): Promise<void> => {
  await apiClient.delete(`admin/scaling/${formatId}/${themeId}/${sportIdentifier}`);
};
